import React, { useMemo } from "react";
import PropTypes from "prop-types";
import { removeAccents } from "../../../utils";
import SectionStyled, { SectionContentStyled } from "./Section.Styled";

export const SectionContent = (props) => <SectionContentStyled {...props} />;

SectionContent.defaultProps = {
  desktopFlexed: false,
  spaceSlim: false,
};

SectionContent.propTypes = {
  desktopFlexed: PropTypes.bool,
  spaceSlim: PropTypes.bool,
};

const Section = (props) => {
  const {
    children,
    as: Component,
    variant,
    sectionName,
    className: propsClassName,
  } = props;

  const backgroundColor = useMemo(
    () => (variant !== "neutral" ? `Section__Background` : ""),
    [variant]
  );

  const dataSection = useMemo(() => removeAccents(sectionName).toLowerCase(), [
    sectionName,
  ]);

  const className = useMemo(
    () =>
      ["make-section", backgroundColor, propsClassName]
        .filter((x) => x)
        .join(" "),
    [backgroundColor, propsClassName]
  );

  return (
    <SectionStyled
      variant={variant}
      className={className}
      data-section={dataSection}
    >
      {Component ? React.createElement(Component, props) : children}
    </SectionStyled>
  );
};

Section.defaultProps = {
  as: null,
  variant: "neutral",
};

Section.propTypes = {
  as: PropTypes.elementType,
  variant: PropTypes.oneOf([
    "neutral",
    "primary",
    "secondary",
    "tertiary",
    "quaternary",
  ]),
  sectionName: PropTypes.string.isRequired,
};

export default Section;
